"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const ErrorApiKeyRenderer_1 = __importDefault(require("../ErrorApiKeyRenderer"));
const linearRoutesCalculator_1 = __importDefault(require("../../../shared/linearRoutesCalculator"));
const customMapStyles_1 = __importDefault(require("./customMapStyles"));
const valueIsString_1 = __importDefault(require("../../../typeAssertions/valueIsString"));
const valueIsMapType_1 = __importDefault(require("../../../typeAssertions/valueIsMapType"));
const valueIsMapTheme_1 = __importDefault(require("../../../typeAssertions/valueIsMapTheme"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../../shared/getValueByPathFromUnknown"));
const valueIsNumber_1 = __importDefault(require("../../../typeAssertions/valueIsNumber"));
const valueIsControlsColorSpecification_1 = __importDefault(require("../../../typeAssertions/valueIsControlsColorSpecification"));
const castNumberToCoordinate_1 = __importDefault(require("../../../shared/castNumberToCoordinate"));
const getMapPoligonsFromUnknown_1 = __importDefault(require("../../../shared/getMapPoligonsFromUnknown"));
const reduceValidMarkers_1 = __importDefault(require("./reduceValidMarkers"));
const reduceValidCircle_1 = __importDefault(require("./reduceValidCircle"));
const valueIsNotUndefined_1 = __importDefault(require("../../../typeAssertions/valueIsNotUndefined"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const controlColorGetValueFromSpecification_1 = __importDefault(require("../../../shared/controlColorGetValueFromSpecification"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const computeComplexUnit_1 = __importDefault(require("../../../ControlStyleFormaters/shared/computeComplexUnit"));
const animatedGetValueWithTry_1 = __importDefault(require("../../../shared/animatedGetValueWithTry"));
const mapStyle = { width: '100%', height: '100%' };
const centerMarkerBoxStyle = {
    position: 'absolute',
    marginLeft: -25,
    marginTop: -50,
    left: '50%',
    top: '50%',
    width: 50,
    height: 50,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
const shadowStyle = {
    position: 'absolute',
    bottom: 0,
    width: 13,
    height: 7,
    backgroundColor: 'rgba(128, 128, 128, 0.3)',
    borderRadius: 50,
};
const MapRenderer = ({ map, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const [regionSeted, setRegionSet] = (0, react_1.useState)(false);
    const aspectRatioRef = (0, react_1.useRef)(1);
    const handleDimentionsChange = (0, react_1.useCallback)((event) => {
        const layout = (0, getValueByPathFromUnknown_1.default)(event, ['nativeEvent', 'layout']);
        const width = (0, getValueByPathFromUnknown_1.default)(layout, ['width']);
        const height = (0, getValueByPathFromUnknown_1.default)(layout, ['height']);
        if ((0, valueIsNumber_1.default)(width) && (0, valueIsNumber_1.default)(height)) {
            aspectRatioRef.current = width / height;
        }
        else {
            aspectRatioRef.current = 1;
        }
    }, []);
    const { Render, Animated, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const buildOrders = processor.root.getBuildOrders();
    const shadeBases = (_a = buildOrders === null || buildOrders === void 0 ? void 0 : buildOrders.palette) === null || _a === void 0 ? void 0 : _a.shadeBases;
    const googleApiKey = (_b = buildOrders === null || buildOrders === void 0 ? void 0 : buildOrders.googleApis) === null || _b === void 0 ? void 0 : _b.googleApiKey;
    const platform = processor.root.platformOS;
    const getColorFromSpecification = (0, react_1.useCallback)((specification) => {
        if ((0, valueIsControlsColorSpecification_1.default)(specification)) {
            if (shadeBases) {
                return (0, controlColorGetValueFromSpecification_1.default)({
                    shadeBases,
                    specification,
                });
            }
        }
        if ((0, valueIsString_1.default)(specification)) {
            return specification;
        }
        return undefined;
    }, [shadeBases]);
    const handleOnMapReady = (0, react_1.useCallback)(() => setRegionSet(true), []);
    const animatedMarginTop = (0, react_1.useMemo)(() => (0, animatedGetValueWithTry_1.default)(() => new Animated
        .Value(0)), [Animated]);
    const events = (0, useControlEvents_1.default)(map);
    (0, useOnLoad_1.default)(map, events);
    const region = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return ({
            latitude: (0, castNumberToCoordinate_1.default)((_a = map.region) === null || _a === void 0 ? void 0 : _a.latitude) || 19.2573425,
            longitude: (0, castNumberToCoordinate_1.default)((_b = map.region) === null || _b === void 0 ? void 0 : _b.longitude) || -99.5799814,
            isFromCallback: !!((_c = map.region) === null || _c === void 0 ? void 0 : _c.isFromCallback),
        });
    }, [map.region]);
    const animateToRegion = (0, react_1.useMemo)(() => {
        if (regionSeted && !region.isFromCallback) {
            return region;
        }
        return undefined;
    }, [region, regionSeted]);
    const routesPolyline = (0, react_1.useMemo)(() => {
        if (!map.routes) {
            return {};
        }
        return (0, linearRoutesCalculator_1.default)(getColorFromSpecification)(map.routes);
    }, [getColorFromSpecification, map.routes]);
    const linearRoutes = (0, react_1.useMemo)(() => {
        if (!map.linearRoutes) {
            return {};
        }
        return (0, linearRoutesCalculator_1.default)(getColorFromSpecification)(map.linearRoutes);
    }, [getColorFromSpecification, map.linearRoutes]);
    const markers = (0, react_1.useMemo)(() => {
        if (!map.markers) {
            return {};
        }
        return (0, reduceValidMarkers_1.default)(map.markers);
    }, [map.markers]);
    const fitToSuppliedMarkers = (0, react_1.useMemo)(() => {
        if (map.centerMarkers) {
            return Object.keys(markers);
        }
        return undefined;
    }, [map.centerMarkers, markers]);
    const areas = (0, react_1.useMemo)(() => {
        if (!map.areas) {
            return {};
        }
        return (0, reduceValidCircle_1.default)(map.areas, getColorFromSpecification);
    }, [map.areas, getColorFromSpecification]);
    const polygons = (0, react_1.useMemo)(() => {
        if (!map.polygons) {
            return {};
        }
        return (0, getMapPoligonsFromUnknown_1.default)({
            polygons: map.polygons,
            getColorFromSpecification,
        });
    }, [map.polygons, getColorFromSpecification]);
    const shouldShowCentralIcon = (0, react_1.useMemo)(() => !!map.shouldShowCentralIcon, [map.shouldShowCentralIcon]);
    const handleOnRegionChangeComplete = (0, react_1.useCallback)((newRegion, newZoom) => {
        if (Animated && (0, valueIsNotUndefined_1.default)(animatedMarginTop)) {
            Animated.timing(animatedMarginTop, {
                toValue: 0,
                duration: 150,
                useNativeDriver: false,
            }).start();
        }
        processor.root.updateControlById({
            control: map,
            dataToUpdate: {
                region: {
                    latitude: newRegion.latitude,
                    longitude: newRegion.longitude,
                    isFromCallback: true,
                },
                zoom: newZoom,
            },
        });
        if (events.onRegionChangeComplete) {
            events.onRegionChangeComplete({
                latitude: newRegion.latitude,
                longitude: newRegion.longitude,
            });
        }
    }, [
        map,
        processor,
        events,
        animatedMarginTop,
        Animated,
    ]);
    const handleOnRegionChange = (0, react_1.useCallback)((newRegion) => {
        if (Animated && (0, valueIsNotUndefined_1.default)(animatedMarginTop)) {
            Animated.timing(animatedMarginTop, {
                toValue: -30,
                duration: 150,
                useNativeDriver: false,
            }).start();
        }
        if (events.onRegionChange) {
            events.onRegionChange(newRegion);
        }
    }, [events, Animated, animatedMarginTop]);
    const isEnabled = !map.isDisabled;
    const centerMarkerStyle = (0, react_1.useMemo)(() => ({
        margin: 0,
        marginTop: animatedMarginTop,
        width: '100%',
        height: 50,
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
    }), [animatedMarginTop]);
    const customMapStyle = (0, react_1.useMemo)(() => {
        if (!(0, valueIsMapTheme_1.default)(map.mapTheme)) {
            return [];
        }
        return customMapStyles_1.default[map.mapTheme];
    }, [map.mapTheme]);
    const centralIconURLSource = (0, react_1.useMemo)(() => {
        if (!map.centralIconURL) {
            return {
                uri: 'https://firebasestorage.googleapis.com/v0/b/apphive-inc.appspot.com/o/resources%2Fmedia%2FapphiveIcons%2FApphiveMapMarker.png?alt=media&token=d18f4b86-e32a-4efd-986f-5756fdadd970',
            };
        }
        return { uri: map.centralIconURL };
    }, [map.centralIconURL]);
    const showsUserLocation = (0, react_1.useMemo)(() => map.showCurrentLocationPointer, [map.showCurrentLocationPointer]);
    const handleMarkerPressed = (0, react_1.useCallback)((marker) => {
        if (events.onMarkerPressed) {
            events.onMarkerPressed(marker);
        }
    }, [events]);
    const mapType = (0, react_1.useMemo)(() => {
        if ((0, valueIsMapType_1.default)(map.mapType)) {
            return map.mapType;
        }
        return 'standard';
    }, [map.mapType]);
    const realZoom = (0, react_1.useMemo)(() => {
        let fromControl;
        try {
            fromControl = (0, getNumberFromUnknown_1.default)(map.zoom);
        }
        catch (_a) {
            fromControl = 0.2;
        }
        if (fromControl > 100) {
            return 100;
        }
        if (fromControl < 0.001) {
            return 0.001;
        }
        return fromControl;
    }, [map.zoom]);
    if (platform && !googleApiKey) {
        return (react_1.default.createElement(ErrorApiKeyRenderer_1.default, { style: {
                width: (0, computeComplexUnit_1.default)((_c = map.style) === null || _c === void 0 ? void 0 : _c.width),
                height: (0, computeComplexUnit_1.default)((_d = map.style) === null || _d === void 0 ? void 0 : _d.height),
                minHeight: (0, computeComplexUnit_1.default)((_e = map.style) === null || _e === void 0 ? void 0 : _e.height),
                maxHeight: (0, computeComplexUnit_1.default)((_f = map.style) === null || _f === void 0 ? void 0 : _f.height),
            }, platform: platform }));
    }
    return (react_1.default.createElement(Render.View, { style: {
            width: (0, computeComplexUnit_1.default)((_g = map.style) === null || _g === void 0 ? void 0 : _g.width),
            height: (0, computeComplexUnit_1.default)((_h = map.style) === null || _h === void 0 ? void 0 : _h.height),
            minHeight: (0, computeComplexUnit_1.default)((_j = map.style) === null || _j === void 0 ? void 0 : _j.height),
            maxHeight: (0, computeComplexUnit_1.default)((_k = map.style) === null || _k === void 0 ? void 0 : _k.height),
            position: 'relative',
        }, onLayout: handleDimentionsChange },
        react_1.default.createElement(Render.MapView, { animateToRegion: animateToRegion, aspectRatioRef: aspectRatioRef, region: region, zoom: realZoom, fitToSuppliedMarkers: fitToSuppliedMarkers, style: mapStyle, onRegionChange: handleOnRegionChange, onRegionChangeComplete: handleOnRegionChangeComplete, onMapReady: handleOnMapReady, showsUserLocation: showsUserLocation, pitchEnabled: isEnabled, rotateEnabled: isEnabled, scrollEnabled: isEnabled, zoomEnabled: isEnabled, customMapStyle: customMapStyle, mapType: mapType },
            Object.entries(areas).map(([areaId, area]) => (react_1.default.createElement(Render.MapCircle, { key: areaId, center: area.center, radius: area.radius, strokeWidth: area.strokeWidth, strokeColor: area.strokeColor, fillColor: area.fillColor }))),
            Object.entries(polygons).map(([polygonId, polygon]) => (react_1.default.createElement(Render.MapPolygon, { key: polygonId, coordinates: polygon.coordinates, strokeWidth: polygon.strokeWidth, strokeColor: polygon.strokeColor, fillColor: polygon.fillColor }))),
            Object.entries(markers).map(([markerId, marker]) => {
                var _a, _b;
                return (react_1.default.createElement(Render.MapMarker, { key: `${markerId}${marker.width}${marker.height}${marker.degrees}`, identifier: markerId, coordinate: marker.coordinate, title: marker.title || markerId, description: ((_a = marker.description) === null || _a === void 0 ? void 0 : _a.toString()) || '', rotation: marker.rotation, icon: (_b = marker.image) !== null && _b !== void 0 ? _b : undefined, width: marker.width, height: marker.height, degrees: marker.degrees, onPress: () => handleMarkerPressed({ markerId, marker }) }));
            }),
            Object.entries(routesPolyline).map(([key, route]) => (react_1.default.createElement(Render.MapPolyLine, { key: key, isRoute: true, googleApiKey: googleApiKey, coordinates: route.coordinates, strokeWidth: route.width, strokeColor: route.color }))),
            Object.entries(linearRoutes).map(([key, route]) => (react_1.default.createElement(Render.MapPolyLine, { key: key, coordinates: route.coordinates, strokeWidth: route.width, strokeColor: route.color })))),
        shouldShowCentralIcon && (react_1.default.createElement(Render.View, { style: centerMarkerBoxStyle },
            react_1.default.createElement(Render.AnimatedImage, { resizeMode: "contain", style: centerMarkerStyle, source: centralIconURLSource }),
            react_1.default.createElement(Render.View, { style: shadowStyle })))));
};
exports.default = MapRenderer;
